const addClickToScrollEventsForNavItems = (productNavigationLinks) => {
    productNavigationLinks.forEach(navigationLink => {
        navigationLink.addEventListener('click', (e) => {
            const disablePrevent = navigationLink.getAttribute('data-no-prevent');

            if (disablePrevent !== "true") {
                e.preventDefault();
            }

            const selectedLinkId = navigationLink.getAttribute('data-tab-id');
            const selectedTab = $('section[data-tab-id="' + selectedLinkId + '"]');

            if (!selectedTab.length) return;

            $('html,body').animate({scrollTop: selectedTab.offset().top - 62}, 'slow');
        })
    })
}

const handleContentNavigationIntersection = (entries, observer) => {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            const stickys = document.querySelectorAll('.js-sticky-product-description-nav-item');

            stickys.forEach(sticky => {
                sticky.setAttribute('data-active', false);
            })

            const selectedLinkId = entry.target.getAttribute('data-tab-id');
            const relatedStickyLink = document.querySelector('.js-sticky-product-description-nav-item[data-tab-id="' + selectedLinkId + '"]');

            if (relatedStickyLink) {
                relatedStickyLink.setAttribute('data-active', true);
            }
        }
    });
}

const copyCartButtonDynProducts = () => {
    const addToCartButtons = document.querySelectorAll("#AddToCart");
    if (addToCartButtons.length < 2) return;

    const addToCartBtn = addToCartButtons[1];
    const addToCartStickyBtn = document.getElementById("AddToCartSticky");

    if (addToCartStickyBtn === null) return;

    addToCartStickyBtn.addEventListener("click", (e) => {
        e.preventDefault();
        addToCartBtn.click();
    })
}

let observer;

const setupObserver = () => {
    const productNavigationLinks = document.querySelectorAll('[data-tab-id]');

    const topMargin = 60; 
    const bottomMargin = window.innerHeight - 70;

    const options = {
        root: null,
        rootMargin: `-${topMargin}px 0px -${bottomMargin}px 0px`,
        threshold: 0
    }

    if (observer) {
        observer.disconnect();
    }

    observer = new IntersectionObserver(handleContentNavigationIntersection, options);

    productNavigationLinks.forEach(navigationLink => {
        const selectedLinkId = navigationLink.getAttribute('data-tab-id');
        const observeSection = document.querySelector('section[data-tab-id="' + selectedLinkId + '"]');

        if (!observeSection) return;

        observer.observe(observeSection);
    })
}

$(window).on("load", function () {
    const productNavigationLinks = document.querySelectorAll('[data-tab-id]');
    addClickToScrollEventsForNavItems(productNavigationLinks);

    setupObserver();
    
    copyCartButtonDynProducts();

    window.addEventListener('resize', setupObserver);
});
